import axios from 'axios';
import { baseURL } from '../Constants';

const url = `${baseURL}/SmokeReplay`;

export interface SmokeClipRequestDTO {
    id: number;
    gameId: string;
    matchId: string;
    season: number;
    roundNumber: number;
    mapName: string | null;
    throwerSteamId: string;
    throwTick: number;
    throwerSlot: number;
    smokeEntityId: number | null;
    clipStatus: 'pending' | 'requested' | 'queued' | 'recording' | 'completed' | 'failed';
    clipUrl: string | null;
    clipThumbnailUrl: string | null;
}

export const getClipRequestsForRound = async (gameId: string, roundNumber: number): Promise<SmokeClipRequestDTO[]> => {
    try {
        const response = await axios.get(`${url}/clips/${gameId}/${roundNumber}`);
        return response.data;
    } catch {
        return [];
    }
};

export const requestSmokeClip = async (
    body: {
        gameId: string;
        matchId: string;
        season: number;
        roundNumber: number;
        mapName: string;
        throwerSteamId: string;
        throwTick: number;
        throwerSlot: number;
        smokeEntityId: number | null;
    },
    token: string
): Promise<{ id: number; clipStatus: string }> => {
    const response = await axios.post(`${url}/request`, body, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

export const getSmokeClipStatus = async (id: number): Promise<{ clipStatus: string; clipUrl: string | null; clipThumbnailUrl: string | null }> => {
    const response = await axios.get(`${url}/status/${id}`);
    return response.data;
};
